import { GlobalState } from '@leverege/ui-redux';
import { DefaultHistoryQueryTriggerHandler } from '@leverege/molten/data-viewers';
class BQQueryTriggerHandler extends DefaultHistoryQueryTriggerHandler {
  postQuery() {
    const {
      delegate,
      queryName
    } = this.options;
    const data = delegate.historyDelegate.getList(GlobalState.get(), queryName, {
      getAll: true
    });
    if (this.options.shouldReloadData?.() !== false && data?.source !== 'long') {
      this.timerId = setTimeout(this.options.loadData, this.refreshTime);
    }
  }
}
export default {
  id: 'recovr.BQQueryTrigger',
  matches: {
    objectType: '*'
  },
  handler: BQQueryTriggerHandler
};